package us.laantech.common.dto

import kotlinx.serialization.Serializable

@Serializable
data class EmployeeDTO(
    val uuid: String,
    val accountSub: String? = null, // login account subject if they're allowed to login

    val companyBranchUuids: Set<String>? = emptySet(), // Branches where the employee has clocked in at

    val employeeName: String?,
    val employeePin: String?,

    val payRateCents: Long?,
    val payPeriod: PayPeriod? = null,
    val payDay: Int? = null,

    //TODO    val schedule: String?,

    // Metadata
    val address: UnitedStatesPostalAddress? = null
){
    init {
        employeePin?.let {
            require(it.length == 4) {
                "Employee pin must be 4 digits"
            }
        }
    }
}

enum class PayPeriod {
    HOURLY,
    DAILY,
    WEEKLY,
    BI_WEEKLY,
    MONTHLY,
    YEARLY,
}

/**
 * TimecardDTO represents a timecard for an employee.
 *
 * When an employee clocks in, they may be signed in to multiple POS devices.
 * Therefore time card is per device
 * Therefore salary computations must be merged first
 *
 * TODO handle unclosed shifts
 *
 */
@Serializable
data class TimecardDTO(
    val employeeUuid: String,

    // The employee may be signed in to multiple POS devices,
    // create a new timecard for each device
    // merge overlapping timecards to compute employee salary.
    val posId: String,

    val clockIn: Long,
    val clockOut: Long? = null,

    // Pos device id and starting balance
    val posStartingBalancesCents: Long? = null,
    val posEndingBalancesCents: Long? = null,

    /*
    TODO handle scenario:
        employee starts shift with a pay rate, and starts another shift with a different pay rate
     */
    val payPeriod: PayPeriod?,
    val payRateCents: Long?,
    )